import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/Sli/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>Why is the SLI</span>{' '}
              <span>a lifesaver?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              It bridges the gap between sales and operations.
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>Legal Protection:</span>{' '}
                It often grants the forwarder permission to file the Electronic Export
                Information (EEI) or other customs filings. Without it, the forwarder
                is acting without authority.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Data Accuracy:</span>{' '}
                It puts the responsibility of data (like HS codes and value) on the
                shipper, reducing the forwarder's liability if the shipper provides bad info.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Insurance:</span>{' '}
                It forces the shipper to check a box: "Yes, insure this" or "No, do not
                insure." This simple checkmark resolves million-dollar disputes if cargo gets damaged.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;